import React from 'react';
import {
	isIssueTypeNameFilter,
	type ConnectionFieldIssueTypeFilter,
} from '@jira/polaris__domain-field/src/ConnectionFieldIssueTypeFilter.types.tsx';
import { IssueTypeIcon } from '@jira/polaris__component-issue-types/src/IssueTypeIcon.tsx';
import { useIssueTypeByNameAndProjectIds } from '@jira/polaris__component-issue-types/src/useIssueTypeName.tsx';
import { defaultProps } from '@jira/platform__default-props/src/defaultProps.tsx';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import ChangesIcon from '@atlaskit/icon/core/changes';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';

const connection = defineMessage({
	id: 'polaris-component-glyphs.glyphs.connection.connection',
	defaultMessage: 'Connection',
	description: 'Label for the connection field icon',
});

type Props = {
	issueTypeFilters?: ConnectionFieldIssueTypeFilter[];
};

export const ConnectionFieldIcon = ({
	issueTypeFilters = fg('jfp_magma_jira-stable-defaultprops') ? defaultProps.emptyArray : [],
}: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const issueTypeNameFilter = issueTypeFilters.find(isIssueTypeNameFilter);
	const issueTypeByName = useIssueTypeByNameAndProjectIds({
		name: issueTypeNameFilter?.names[0],
		projectIds: issueTypeNameFilter?.projectIds,
	});

	if (issueTypeByName) {
		return (
			<Flex alignItems="center">
				<IssueTypeIcon issueTypeId={issueTypeByName.id} />
			</Flex>
		);
	}

	return <ChangesIcon label={formatMessage(connection)} color="var(--ds-icon)" />;
};
